<template>
    <b-badge v-if="paRequired" variant="danger">Required</b-badge>
    <b-badge v-else-if="paNotRequired" variant="success">Not Required</b-badge>
    <b-badge v-else variant="info">Not Provided</b-badge>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: "RTPBPARequired",
    components: {}
})
export default class RTPBPARequired extends Vue {
    @Prop({ required: true }) protected pricingCoverage!: any;

    get paRequired() {
        return this.pricingCoverage.priorAuthRequiredSpecified && this.pricingCoverage.priorAuthRequired === 0;
    }

    get paNotRequired() {
        return this.pricingCoverage.priorAuthRequiredSpecified && this.pricingCoverage.priorAuthRequired === 1;
    }
}

</script>